"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const layout_1 = require("./layout.js");
function EmbedLayoutComponent({ children }) {
    const items = react_1.default.Children.toArray(children);
    const isSlot = (type) => (child) => react_1.default.isValidElement(child) && child.type === type;
    const header = items.filter(isSlot(layout_1.Layout.Header));
    const footer = items.filter(isSlot(layout_1.Layout.Footer));
    const body = items.filter((child) => !isSlot(layout_1.Layout.Header)(child) && !isSlot(layout_1.Layout.Footer)(child));
    return ((0, jsx_runtime_1.jsxs)("div", { className: "koa:relative koa:flex koa:h-dvh koa:flex-col koa:overflow-hidden", children: [header, (0, jsx_runtime_1.jsx)("div", { className: "koa:relative koa:flex koa:min-h-0 koa:flex-1 koa:flex-col koa:overflow-y-auto koa:pt-4 koa:[mask-image:linear-gradient(to_bottom,transparent,black_1rem)] koa:max-sm:justify-between", children: body }), footer] }));
}
EmbedLayoutComponent.displayName = "EmbedLayout";
exports.EmbedLayout = Object.assign(EmbedLayoutComponent, {
    Header: layout_1.Layout.Header,
    Content: layout_1.Layout.Content,
    BottomNavigation: layout_1.Layout.BottomNavigation,
    Footer: layout_1.Layout.Footer,
});
